import { useState, useEffect } from 'react'
import './App.css'
import Header from './components/header/header'
import {getRootUrl} from './consts.js'

function App() {
  useEffect(() => {
    document.title = 'Willowest Enterprise Co., Ltd.';
  }, []);

  const [count, setCount] = useState(0)

  return (
    <>
      <Header />
      <a href={getRootUrl()+"/app2"}>app2</a>
    </>
  )
}

export default App
